import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const OnboardingLayoutScrollableContent = ({ className, children }) => {
  const classes = classNames({
    'onboarding-layout-scrollable-content': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

OnboardingLayoutScrollableContent.propTypes = propTypes;

export default OnboardingLayoutScrollableContent;
